import { a as o_global } from "../chunks/common-namespaces-client-DXKc2YAH.mjs";
const breakpoint = o_global.breakpoint ?? {};
const globalBreakpoint = o_global.globalBreakpoint;
export {
  breakpoint,
  globalBreakpoint
};
/*                                          */
